// import { PROFILE } from '../Constants'
import { GET_ROLE } from '../actions/role-org.action'

const initState = {
  role: ''
}
// const profile = JSON.parse(localStorage.getItem(PROFILE))

const roleReducer = (state = initState, action) => {
  switch (action.type) {
    case GET_ROLE:
      return {
        ...state,
        role: action.payload.role
        // role:  action.payload.role ?? profile.org_id
      }
    default:
      return state
  }
}

export default roleReducer
